import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { GlobalService } from 'src/app/global.service';
import { LoginService } from 'src/app/Common/Services/login.service';
import { NavigationExtras, Router } from '@angular/router';
import { UsercreationeditComponent } from './../usercreationedit/usercreationedit.component';

export interface PeriodicElement {
  userid:String;
  name: string;
  mobileno: number;
  emailid: String;
  status: string;
  usertype:String;
  suminsured:number;
  premiumlimit:number;
  validupto:Date;
}

@Component({
  selector: 'app-user-create-listing',
  templateUrl: './user-create-listing.component.html',
  styleUrls: ['./user-create-listing.component.css']
})
export class UserCreateListingComponent implements OnInit {

  constructor(public global: GlobalService, public dialog: MatDialog, public loginservice:LoginService, public router:Router) { }
  displayedColumns: string[] = ['username', 'name', 'emailid', 'mobileno','usertype','suminsured','premiumlimit','status','validupto','action'];
  dataSource ;
  userList : PeriodicElement[] = [];

  opencreateeditDialog(element): void {
    
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "username" : element.username,
        "flowMode" : "EDIT"
      }
    }
    this.router.navigate(["/usercreation"], navigationExtras);
    const dialogRef = this.dialog.open(UsercreationeditComponent, {
      panelClass:'dialogPopclass'
    });
  }


  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;


  ngOnInit() {
   // this.dataSource.paginator = this.paginator;
   this.getuserListing();
  }


  getuserListing(){
    
    var agentId = sessionStorage.getItem('agentId');
    this.loginservice.getuserListing(agentId).subscribe((res:any) => {
      if(res.responseBody != undefined){
        console.log("User Listing :", res.responseBody);
        this.userList = res.responseBody.list;
        console.log("Listing:", this.userList)
        this.dataSource = new MatTableDataSource(this.userList);
        this.dataSource.paginator = this.paginator;
      }
      
    })
  }
}


